import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

type FindLearningOutcomesParams = {
  search: string;
  lang: string;
};

const { useCreate: useLazyLearningOutcomes } = getCRUDHooks({
  entityName: 'learning-outcomes',
  create: ({ search, lang }: FindLearningOutcomesParams) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.learningOutcomes.getLearningOutcomes(search, lang),
});

export default useLazyLearningOutcomes;
